import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Textbox from '../../../assets/saola/elements/forms/text-field';
import FormCheckbox from '../../../assets/saola/elements/forms/check-box';
import FormField from '../../../assets/saola/elements/forms/form-field';
import { USER_AGREEMENTS, VALIDATION } from '../../../constants';
import Agreements from '../../../assets/containers/RegistrationAgreements';

/**
 * Partial for registering a user on the platform.
 */
class SignUpForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      emailHasError: false,
      passwordHasError: false,
      receiveMarketing: false,
      receiveOpportunities: false,
      outdatedAgreements: USER_AGREEMENTS.map(a => ({...a, hasError: false})),
    };
  }

  /**
   * Validates an email address
   * @returns {boolean} whether the email address is valid.
   */
  validateEmail = (email) => {
    const emailExpression = VALIDATION.email;
    return email.trim().length > 0 && emailExpression.test(email);
  }

  /**
   * Validates a password
   * @returns {boolean} whether the password is valid.
   */
  validatePassword = (password) => {
    const lowercaseExpression = new RegExp('^(?=.*[a-z]).+$');
    const uppercaseExpression = new RegExp('^(?=.*[A-Z]).+$');
    const containsDigit = new RegExp('^(?=.*[0-9]).+$');
    const minLength = 5;

    return password.trim().length > minLength &&
      lowercaseExpression.test(password) &&
      uppercaseExpression.test(password) &&
      containsDigit.test(password);
  }

  isAgreementsValid = (agreements) => {
    return agreements.filter(a => a.accepted_date === undefined).length > 0
  }

  /**
   * Handler for when the email address changes.
   */
  handleEmailChange = (evt) => {
    this.setState({
      email: evt.target.value,
      emailHasError: !this.validateEmail(evt.target.value),
    });
  }

  /**
   * Handler for when the password changes.
   */
  handlePasswordChange = (evt) => {
    this.setState({
      password: evt.target.value,
      passwordHasError: !this.validatePassword(evt.target.value),
    });
  }

  handleMarketingChange = (evt) => {
    this.setState({
      receiveMarketing: evt.target.checked,
    });
  }

  handleOpportunitiesChange = (evt) => {
    this.setState({
      receiveOpportunities: evt.target.checked,
    });
  }

  handleAgreementsAccept = (agreements) => {
    this.setState({
      ...this.state,
      agreementError: this.isAgreementsValid(agreements),
      outdatedAgreements: agreements
    })
  }

  handleSubmit = () => {
    const {
      email,
      password,
      receiveMarketing,
      receiveOpportunities,
      outdatedAgreements,
    } = this.state;

    const {
      submit,
      terms,
    } = this.props;

    const emailHasError = this.validateEmail(email) === false;
    const passwordHasError = this.validatePassword(password) === false;

    if (emailHasError || passwordHasError || !outdatedAgreements.every(a => a?.accepted_date > a?.revision_date)) {
      const agreementError = this.isAgreementsValid(outdatedAgreements)

      this.setState({
        ...this.state, agreementError: agreementError, outdatedAgreements: outdatedAgreements.map(a => {
        return a.accepted_date === undefined ? { ...a, hasError: true } : a
      }), emailHasError, passwordHasError})
    } else {
        submit({
          email,
          password,
          receiveMarketing,
          receiveOpportunities,
            }, outdatedAgreements
          );
    } 
  }

  render() {
    const {
      email,
      password,
      emailHasError,
      passwordHasError,
      receiveMarketing,
      receiveOpportunities,
      outdatedAgreements,
    } = this.state;

    return (
      <form>

        <FormField
          helpMessage='You need to enter a valid email.'
          hasError={ emailHasError }
          required
          forField='field-email'
          label='Email'
        >
          <Textbox
            id='field-email'
            inputValue={ email }
            onChange={ this.handleEmailChange }
          />
        </FormField>

        <FormField
          forField='field-password'
          label='Password'
          inputValue={ password }
          inputType='password'
          helpMessage='Passwords must be longer than 6 characters and include lowercase, uppercase letters &amp; at least one digit.'
          hasError={ passwordHasError }
          showHelpMessageWhenValid={ true }
          required
        >
          <Textbox
            id='field-password'
            inputValue={ password }
            inputType='password'
            onChange={ this.handlePasswordChange }
          />
        </FormField>

        <div className='o-fieldset'>

          <FormField forGroup='group-communicationprefs'>
            <FormCheckbox
              id='field-marketing'
              text='I want to receive marketing messages.'
              checked={ receiveMarketing }
              onChange={ this.handleMarketingChange }
            />

            <FormCheckbox
              id='field-opportunities'
              text='I want to receive investment opportunities.'
              checked={ receiveOpportunities }
              onChange={ this.handleOpportunitiesChange }
            />
          </FormField>

        </div>

        <Agreements
          outdatedAgreements={outdatedAgreements}
          handleAccept={(agreements) => this.handleAgreementsAccept(agreements)}
          hasError={ this.state.agreementError }
        />


        <footer className='o-controls'>
          <ul>
            <li>
              <button
                type="button"
                className="p-button"
                onClick={ () => this.handleSubmit() }
              >
                Sign Up
              </button>
            </li>
          </ul>
        </footer>

      </form>);
  }
}

SignUpForm.propTypes = {
  submit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  terms: PropTypes.string,
};

export default SignUpForm;
